const dark = {
  xs: "0px 2px 2px 0px rgba(0,0,0,1)",
  sm: "0px 5px 5px 0px rgba(0,0,0,1)",
  md: "0px 5px 10px 2px rgba(0,0,0,1)",
  lg: "0px 5px 15px 5px rgba(0,0,0,1)",
}

export default dark
